import { HttpClient } from '@angular/common/http';
import { AfterContentInit, AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { FormsModule } from "@angular/forms";
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

@Component({
  selector: 'app-selezione',
  templateUrl: './selezione.component.html',
  styleUrls: ['./selezione.component.css']
})
export class SelezioneComponent implements OnInit, AfterContentInit{
  @ViewChild(DxDataGridComponent, { static: false }) grid: DxDataGridComponent;
  @Input() colonne :string[] ;
  @Input() api = '';
  @Input() tipoSelezione='single';
  @Output() selezione: EventEmitter<any> = new EventEmitter();
  @Input()  ppVisible :boolean =false;
  @Output() ppVisibleChange = new EventEmitter<boolean>();
  @Input() recSelezionati:any[];
  _dsSelezione: any;
  _BaseUrl='';

  constructor(private http:HttpClient) {




   }

  ngOnInit(): void {
    this.http.get(this._BaseUrl+this.api).toPromise().then(res => {this._dsSelezione=res });


  }

  selezionati(){

    this.selezione.emit(this.grid.instance.getSelectedRowsData());
    this.chiudi();


  }

  chiudi(){
    this.ppVisible=false;
    this.ppVisibleChange.emit(this.ppVisible);

  }
  apri(){
    this.colonne.forEach(colonna => {
      this.grid.instance.addColumn(colonna);
    })
    if (this.recSelezionati != null){

      this.grid.instance.selectRows(this.recSelezionati,false);
    }

  }
  ngAfterContentInit():void{

  }

  exportGrid(e:any) {
    const doc = new jsPDF();
    exportDataGridToPdf({
        jsPDFDocument: doc,
        component: this.grid.instance
    }).then(() => {
        doc.save('Customers.pdf');
    })
  }
}
